/*
  Free-shipping message + progress bar for the Kaching cart drawer.

  Renders into a merchant-placed element `#rl-free-shipping-bar` (add it via a
  Kaching custom-HTML block or anywhere in the drawer). Logic:

    - If ANY cart line has a selling plan (subscription)  -> free shipping (unlocked).
    - Otherwise (all one-time)                            -> progress toward the
      threshold, based on the cart total AFTER discounts.

  Config comes from theme settings, exposed on window.RLFreeShipping (see theme.liquid):
    enabled, threshold (£, integer), msgSubscription, msgUnlocked, msgProgress
    ([amount] token), moneyFormat (shop.money_format, used for the currency symbol).

  Markup reuses Kaching's own `kaching-cart__tiered-promotions-bar*` classes so it
  inherits the app's styling. Updates on drawer open and on any cart re-render; a
  content signature prevents redundant writes (and the self-triggering render loop).
*/
(function () {
  var cfg = window.RLFreeShipping || {};
  if (cfg.enabled != true) return; // disabled via theme settings

  var TARGET_ID = cfg.targetId || "rl-free-shipping-bar";
  var thresholdPence = Math.round((Number(cfg.threshold) || 40) * 100);

  function fmt(pence, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency", currency: currency || "GBP",
        minimumFractionDigits: 0, maximumFractionDigits: 0,
      }).format(pence / 100);
    } catch (e) {
      // Fallback: use the store's money format (window.RLFreeShipping.moneyFormat),
      // substituting the rounded amount into Shopify's {{amount}} placeholder.
      var amount = Math.round(pence / 100).toLocaleString("en");
      var f = (cfg.moneyFormat || "").replace(/<[^>]+>/g, ""); // strip any markup
      return f ? f.replace(/\{\{\s*amount[^}]*\}\}/, amount) : amount;
    }
  }

  function render(cart) {
    var el = document.getElementById(TARGET_ID);
    if (!el || !cart) return;

    var items = cart.items || [];
    var hasSubscription = items.some(function (i) { return i.selling_plan_allocation; });
    var total = typeof cart.totalAfterDiscounts === "number" ? cart.totalAfterDiscounts : cart.total_price;
    var currency = cart.currency || "GBP";

    // Messages are merchant-authored HTML from theme settings (trusted) and render
    // as-is, so bold/other tags in the copy work. [amount] = remaining sum.
    var unlocked, percent, messageHtml;
    if (hasSubscription) {
      unlocked = true;
      percent = 100;
      messageHtml = cfg.msgSubscription || "<b>Free subscription delivery</b> unlocked!";
    } else if (total >= thresholdPence) {
      unlocked = true;
      percent = 100;
      messageHtml = cfg.msgUnlocked || "<b>Free delivery</b> unlocked!";
    } else {
      unlocked = false;
      percent = thresholdPence > 0 ? Math.min(100, Math.round((total / thresholdPence) * 100)) : 0;
      var remaining = Math.max(0, thresholdPence - total);
      messageHtml = (cfg.msgProgress || "Add <b>[amount]</b> to unlock <b>Free delivery</b>!")
        .replace("[amount]", fmt(remaining, currency));
    }

    // Skip if nothing changed — avoids redundant writes and the render->observe->render loop.
    var sig = (unlocked ? "1" : "0") + "|" + percent + "|" + messageHtml;
    if (el.getAttribute("data-fs-sig") === sig) return;

    el.innerHTML =
      '<div class="kaching-cart__tiered-promotions-bar">' +
        '<p class="kaching-cart__tiered-promotions-bar-text">' + messageHtml + "</p>" +
        '<div class="kaching-cart__tiered-promotions-bar-progress-container" dir="ltr">' +
          '<div class="kaching-cart__tiered-promotions-bar-progress-fill" dir="ltr" data-progress-percentage="' +
            percent + '" style="width:' + percent + '%">&nbsp;</div>' +
        "</div>" +
      "</div>";
    el.setAttribute("data-fs-sig", sig);
    el.setAttribute("data-fs-state", unlocked ? "unlocked" : "progress");
  }

  var updating = false;
  function update() {
    var api = window.kachingCartApi;
    if (!api || typeof api.getCartData !== "function") return;
    if (updating) return;
    updating = true;
    Promise.resolve(api.getCartData())
      .then(render)
      .catch(function () {})
      .then(function () { updating = false; });
  }

  var debounce;
  function scheduleUpdate() {
    clearTimeout(debounce);
    debounce = setTimeout(update, 60);
  }

  // Drawer open/close toggles a body class.
  new MutationObserver(scheduleUpdate).observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });

  // Re-render whenever Kaching re-renders the drawer (add/remove/qty). Retries
  // because <kaching-cart> mounts asynchronously.
  function observeDrawer() {
    var root = document.querySelector("kaching-cart");
    if (!root) return false;
    new MutationObserver(scheduleUpdate).observe(root, { childList: true, subtree: true });
    return true;
  }
  if (!observeDrawer()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (observeDrawer() || ++tries > 20) clearInterval(iv);
    }, 300);
  }

  scheduleUpdate();
})();
